import React from 'react';
import ReactDOM from 'react-dom';
import Login from './views/Login';
import Dashboard from './views/Dashboard';
import Application from './views/Application/Application';
import Dialog from './components/Dialog/Dialog';
import reportWebVitals from './reportWebVitals';
import createStoreWithPersistor from './store/store';
import Notification from './components/Notification/Notification';
import { BrowserRouter as Router, Route, Routes, } from "react-router-dom";
import { Provider, useSelector, useDispatch } from 'react-redux';
import { clearMessage } from './store/actions/dialogActions';
import { PersistGate } from 'redux-persist/integration/react'
import '@progress/kendo-theme-material/dist/all.css';
import './styles/global.css';
import './styles/kendo-overrides.css';
import App from './views/NCPublic/App';
import Accountdel from './views/NCPublic/Accountdel';
import Redirect from './views/Redirect';

const storeWithPersistor = createStoreWithPersistor();

const AppWrapper = () => {
  const { loggedIn, user } = useSelector(state => state.authReducer);
  const { dialog } = useSelector(state => state.dialogReducer);

  const dispatch = useDispatch();
  return (
    <>
      {dialog.show && 
        <Dialog
          title={dialog.title}
          text={dialog.message}
          type={dialog.type}
          onConfirm={() => dispatch(clearMessage)}
        />}
      <Notification />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/azurelogin/redirect" element={<Redirect />} />
          <Route path="/dashboard" element={loggedIn ? <Dashboard /> : <Login />} />
          <Route path="/application" element={loggedIn && user?.site?.sitePermissions?.some(perm => perm.permissionName === 'APPLICATIONS') ? <Application /> : <Login />} />
          <Route path="/ncpublic" element={<App />} />
          <Route path="/accountdel" element={<Accountdel />} />
        </Routes>
      </Router>
    </>
  )
}

ReactDOM.render(
  <Provider store={storeWithPersistor.store}>
    <PersistGate loading={null} persistor={storeWithPersistor.persistor}>
      <React.StrictMode>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" />

        <AppWrapper />
      </React.StrictMode>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
